export default "/images/9d6f44e8b5c7aa1243aae6804b74cbb9.png";